/* TINOR related products: swaps in Shopify product recommendations
   (Product Recommendations API, ?section_id=) when available. */
(() => {
  async function load(root) {
    if (!root || root.dataset.relatedInit) return;
    root.dataset.relatedInit = '1';
    const section = root.closest('.shopify-section') || root;
    const url = root.dataset.relatedUrl;
    if (!url) {
      if (root.querySelector('[data-related-empty]')) section.hidden = true;
      return;
    }
    try {
      const html = await fetch(url).then(r => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-related-track]');
      const track = root.querySelector('[data-related-track]');
      if (fresh && fresh.children.length) {
        track.innerHTML = fresh.innerHTML;
        track.scrollLeft = 0;
      }
    } catch (_) { /* keep the fallback products */ }
    const track = root.querySelector('[data-related-track]');
    if (!track || !track.children.length) { section.hidden = true; return; }
    if (root.tinorSlider) root.tinorSlider.refresh();
    else if (window.TINORSlider) window.TINORSlider.init(root);
  }
  const boot = (scope = document) => scope.querySelectorAll('.related[data-slider]').forEach(load);
  boot();
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
